import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import en from './translations/en'
import pt_br from './translations/pt-br'

const resources = {
  pt_br,
  en
}

export const availableLanguages = Object.keys(resources)

i18n
.use(initReactI18next)
.use(LanguageDetector)
.init({
  resources,
  defaultNS: "common",
  fallbackLng: "pt_br"
})